import { requisitarJson } from '../../../shared/api/http';

export interface RankingDaTurma {
    turma_id: string;
    nome: string | null;
    ranking: boolean;
}

export function listarTurmas(): Promise<RankingDaTurma[]> {
    return requisitarJson('/api/v1/ranking/turmas');
}

export function alterarRanking(turmaId: string, ranking: boolean, csrfToken: string): Promise<RankingDaTurma> {
    return requisitarJson(`/api/v1/ranking/turmas/${encodeURIComponent(turmaId)}`, {
        method: 'PUT', csrfToken, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ranking }),
    });
}
